import { action } from 'easy-peasy';

import { IActionSetToxicologyReportFilters } from '../types';

const setToxicologyReportFilters: IActionSetToxicologyReportFilters = action((state, filters) => {
  state.toxicology.filters = filters;
});

export default setToxicologyReportFilters;
